<div
  [formGroup]="form"
  [class.is-invalid]="!isValid && (isDirty || isTouched)"
  [class.is-valid]="isValid && (isDirty || isTouched)">
  @if (!hideLabel) {
  <span class="-fontMedium">
    {{ question.label }}
    @if (!question.required && !hideOptional) {
    <span> (Optional)</span>
    }
  </span>
  }
  <div [formGroupName]="question.key" class="form -group-wrapper">
    @for (option of question.options; track option) {
    <div class="form -group-element-wrapper noSelector">
      <label class="form -group-element noSelector">
        <input
          type="checkbox"
          [formControlName]="option.value"
          (click)="preventUncheck(option.defaultChecked); setCheckedValue(option.value)" />
        <span
          class="form -group-element-checkbox -checkbox-blue"
          [ngClass]="{ '-defaulted': option.defaultChecked, '-subCheckbox': question.subCheckbox }">
        </span>
        <span class="restful-checkbox -checkbox-text">
          {{ option.value }}
        </span>
        @if (option.restVerb) {
        <span class="restful-checkbox -checkbox-verb">
          <rest-verb-box [verb]="option.restVerb"></rest-verb-box>
        </span>
        }
        <span class="restful-checkbox -checkbox-subtext" [ngClass]="{ '-bottom-subtext': bottomSubtext }">
          {{ option.secondaryText }}
        </span>
      </label>
    </div>
    }
  </div>

  @if (!isValid && (isDirty || isTouched)) {
  <span class="form -error -fontSmall">
    @if (errors.required) {
    <span> {{ question.label }} is required </span>
    } @if (errors.multiCheckboxRequired) {
    <span> {{ question.label }} is required </span>
    }
  </span>
  }
</div>
